import React from "react"
import badge from "badges/investing-resources.svg"
import { BadgeImage } from "backpack/badges/styled"

const InvestingResources = props => <BadgeImage src={badge} {...props} />

export default InvestingResources
